/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Box, Flex, Img, Radio, RadioGroup, Text, useToast, Stack } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { AiFillSound } from 'react-icons/ai'
import { FaChartPie, FaCheckCircle, FaShare } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { iDemografiaPEC, iQuestao, iRespostaEscala } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { FormatarMensagemEditorDeTexto, useQuery } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { iAcessoPec } from '../Abertura'
import {
  Container,
  HeaderContainer,
  SkillAnswer,
  SkillQuestion,
  ComentarioContainer
} from './styles'

interface iResposta {
  questaoId: string
  respostaId?: string
  nota?: number
  resposta?: string
}

interface iFormQuestao extends iQuestao {
  isError: boolean
  observacao?: string
  avatar: string
  atributoId: string
  ordem?: number
  demografiaId?: string
  perguntaId?: string
  pesoAtrelada?: number
  perguntaAtreladaId?: string
}

interface iAudioFormulario {
  questoes: iAudioQuestao[]
  processado: boolean
}

interface iAudioQuestao {
  questaoId: string
  audioUrl: string
  idioma: string
}

export const RespostaPesquisaPec: React.FC = () => {
  const nav = useNavigate()
  const toast = useToast()
  const refs = useRef<any>([])
  const refsQuestoes = useRef<any>([])
  const refsDemografia = useRef<any>([])
  const refsItensDemografia = useRef<any>([])
  const refsEscala = useRef<any>([])
  const [TipoAudio, setTipoAudio] = useState<number>()
  const { pesquisaId, tokenId } = useParams<{ pesquisaId?: string, tokenId?: string }>()
  const { pathname } = useLocation()
  const { state } = useLocation() as { state?: { acessoPec?: iAcessoPec, acessoId?: string } }

  const acessoId = state?.acessoId ?? localStorage.getItem('acessoPec:id') ?? ''
  const acessoPec: iAcessoPec | null =
    state?.acessoPec ?? JSON.parse(localStorage.getItem('acessoPec') || 'null')

  const [currentAudioIndex, setCurrentAudioIndex] = useState<any>(null)

  const playAudio = (index: number, tipoAudio: number): void => {
    if (currentAudioIndex !== undefined && tipoAudio !== undefined) {
      if (TipoAudio === 0 && refsDemografia.current[currentAudioIndex]) {
        refsDemografia.current[currentAudioIndex].pause()
        refsDemografia.current[currentAudioIndex].currentTime = 0
      } else if (TipoAudio === 1 && refsEscala.current[currentAudioIndex]) {
        refsEscala.current[currentAudioIndex].pause()
        refsEscala.current[currentAudioIndex].currentTime = 0
      } else if (TipoAudio === 2 && refsItensDemografia.current[currentAudioIndex]) {
        refsItensDemografia.current[currentAudioIndex].pause()
        refsItensDemografia.current[currentAudioIndex].currentTime = 0
      } else if (refsQuestoes.current[currentAudioIndex]) {
        refsQuestoes.current[currentAudioIndex].pause()
        refsQuestoes.current[currentAudioIndex].currentTime = 0
      }
    }

    setCurrentAudioIndex(index)
    setTipoAudio(tipoAudio)
    if (tipoAudio === 0) {
      refsDemografia.current[index].play()
    } else if (tipoAudio === 1) {
      refsEscala.current[index].play()
    } else if (tipoAudio === 2) {
      refsItensDemografia.current[index].play()
    } else {
      refsQuestoes.current[index].play()
    }
  }

  const Notas = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  const query = useQuery()
  const quiosque = query.get('m')
  const [Questoes, setQuestoes] = useState<iFormQuestao[]>([])
  const [Errors, setErrors] = useState<string[]>([])
  const [TxtEncerramento, setTxtEncerramento] = useState<string>()
  const [Demografias, setDemografias] = useState<iDemografiaPEC[]>([])
  const [Respostas, setRespostas] = useState<iResposta[]>([])
  const [NomePesquisa, setNomePesquisa] = useState('')
  const [isRespondido, setisRespondido] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingForm, setIsLoadingForm] = useState(true)
  const [LogoEmpresa, setLogoEmpresa] = useState<string>('')
  const [AudiosQuestoes, setAudiosQuestoes] = useState<iAudioFormulario>()
  const [AudiosDemografia, setAudiosDemografia] = useState<iAudioFormulario>()
  const [AudiosItemDemografia, setAudiosItemDemografia] = useState<iAudioFormulario>()
  const [AudiosEscala, setAudiosEscala] = useState<iAudioFormulario>()
  const [EmpresaId, setEmpresaId] = useState<string>('')
  const [PesquisaId, setPesquisaId] = useState<string>('')
  const [LinkRedirecionar, setLinkRedirecionar] = useState<string>()
  const [EscalaRespostas, setEscalaRespostas] = useState<iRespostaEscala[]>([])

  function getFormulario(): void {
    setIsLoading(true)
    pathname.includes('Previsualizar')
      ? appApi.get(`ResponderPec/${pesquisaId}/Previsualizar`)
        .then(resp => {
          setQuestoes(resp.data.questoes)
          setEscalaRespostas(resp.data.respostas)
          setNomePesquisa(resp.data.nomePesquisa)
          setLogoEmpresa(resp.data.logoEmpresa)
          setDemografias(resp.data.demografias)
          setTxtEncerramento(resp.data.txtEncerramento)
          setLinkRedirecionar(resp.data.link)
          setEmpresaId(resp.data.empresaId)
          setPesquisaId(resp.data.pesquisaId)
          setIsLoadingForm(false)
        }).catch(() => setisRespondido(true))
        .finally(() => setIsLoading(false))
      : appApi.get(`ResponderPec/${tokenId}`)
        .then(resp => {
          setQuestoes(resp.data.questoes)
          setEscalaRespostas(resp.data.respostas)
          setNomePesquisa(resp.data.nomePesquisa)
          setLogoEmpresa(resp.data.logoEmpresa)
          setDemografias(resp.data.demografias)
          setTxtEncerramento(resp.data.txtEncerramento)
          setLinkRedirecionar(resp.data.link)
          setEmpresaId(resp.data.empresaId)
          setPesquisaId(resp.data.pesquisaId)
          setIsLoadingForm(false)
        }).catch(() => setisRespondido(true))
        .finally(() => {
          setIsLoading(false)
          if (acessoPec) {
            acessoPec.demografias.forEach(e => {
              SelResposta(e.demografiaId, e.itemDemografiaId)
            })
          }
        })
  }

  function getAudios(): void {
    setIsLoading(true)
    appApi.get(`api/Audio/liberado/${PesquisaId}`)
      .then(resp => {
        if (resp.data === true) {
          appApi.get(`api/Audio/${PesquisaId}`)
            .then(res => {
              const data = res.data as iAudioFormulario
              const itens = data.questoes
              setAudiosDemografia({ ...data, questoes: itens.filter(e => Demografias.some(dem => dem.id === e.questaoId)) })
              setAudiosItemDemografia({ ...data, questoes: itens.filter(e => Demografias.some(dem => dem.demografias?.some(itDem => itDem.id === e.questaoId))) })
              setAudiosQuestoes({ ...data, questoes: itens.filter(e => Questoes.some(q => q.perguntaId === e.questaoId)) })
              setAudiosEscala({ ...data, questoes: itens.filter(e => EscalaRespostas.some(esc => esc.id === e.questaoId)) })
            })
            .catch(err => console.log(err))
        }
      }).catch((err) => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function UpdateResposta(questaoId: string, respostaId?: string, nota?: number, questoesExcluir?: iFormQuestao[]): void {
    const respostas = [...Respostas.filter(e => !questoesExcluir?.some(a => a.perguntaId === e.questaoId))]
    const pos = respostas.findIndex(e => e.questaoId === questaoId)
    if (pos !== -1) {
      if (respostaId) respostas[pos].respostaId = respostaId
      if (nota) respostas[pos].nota = nota
      setRespostas(respostas)
    }
  }

  function UpdateRespostaDiscursiva(questaoId: string, texto: string): void {
    const pos = Respostas.findIndex(e => e.questaoId === questaoId)
    const respostas = [...Respostas]
    if (pos !== -1) {
      respostas[pos].resposta = texto
      setRespostas(respostas)
    } else {
      setRespostas([...Respostas, { questaoId: questaoId, resposta: texto }])
    }
  }

  function GetIdsAtreladas(questaoId: string, respId?: string): string[] {
    const response: string[] = []

    const questao = Questoes.find(e => e.perguntaId === questaoId)
    const peso = EscalaRespostas.find(e => e.id === respId)?.peso
    let questaoAtrelada = Questoes.find(e => e.perguntaId === questao?.perguntaAtreladaId)

    if (peso === -1 || peso === 0 || (questao?.pesoAtrelada && peso && (peso <= questao?.pesoAtrelada))) return response

    while (questaoAtrelada) {
      response.push(questaoAtrelada.perguntaId ?? '')
      questaoAtrelada = Questoes.find(e => e.perguntaId === questaoAtrelada?.perguntaAtreladaId)
    }

    return response
  }

  function SelResposta(questaoId: string, resposId?: string, nota?: number): void {
    const demografia = Demografias.find(e => e.id === questaoId)
    const itemDemografia = Demografias.find(e => e.demografias?.some(a => a.id === resposId))?.demografias?.find(e => e.id === resposId)
    const idsAteladas = GetIdsAtreladas(questaoId, resposId)
    let questoesParaExcluir: iFormQuestao[] = []
    if (demografia && itemDemografia) {
      questoesParaExcluir = Questoes.filter(e => e.demografiaId !== itemDemografia.id && demografia.demografias?.some(a => e.demografiaId === a.id))
    } else if (idsAteladas.length > 0) {
      questoesParaExcluir = Questoes.filter(e => idsAteladas.includes(e.perguntaId ?? ''))
    }

    if (!isSelectQuestao(questaoId)) {
      setRespostas(oldArray => [...oldArray, { questaoId: questaoId, respostaId: resposId, nota: nota }])
    } else {
      if (!isSelect(questaoId, resposId, nota)) {
        UpdateResposta(questaoId, resposId, nota, questoesParaExcluir)
      }
    }
  }

  function AddErrorStats(questoesId: string[]): void {
    const quests = [...Questoes].map((e) => {
      return { ...e, isError: questoesId.includes(e.id) }
    }).sort((a, b) => { return a.tipo - b.tipo })
    if (quests.some(e => e.isError)) {
      refs.current[quests.findIndex(e => e.isError)]?.focus()
    }
    setQuestoes([...quests])
  }

  const isSelect = (perguntaId: string, resposId?: string, nota?: number): boolean => Respostas.find(e => e.questaoId === perguntaId && (e.respostaId === resposId && e.nota === nota)) !== undefined
  const isSelectQuestao = (perguntaId: string): boolean => Respostas.find(e => e.questaoId === perguntaId) !== undefined

  function postForm(): void {
    const semRespostaMarcada = Questoes.filter(e => !Respostas.find(r => r.questaoId === e.perguntaId))

    const naoRespondidas: iFormQuestao[] = []
    semRespostaMarcada.forEach(quest => {
      const questaoAtrelada = Questoes.find(e => e.perguntaAtreladaId === quest.perguntaId)
      if (questaoAtrelada) {
        const resp = Respostas.find(a => a.questaoId === questaoAtrelada.perguntaId)
        if (resp) {
          const peso = EscalaRespostas.find(a => a.id === resp.respostaId)
          if (!peso || (peso.peso <= (questaoAtrelada.pesoAtrelada ?? 0) && peso.peso !== -1)) {
            naoRespondidas.push(quest)
          }
        }
      } else if (quest.demografiaId) {
        const demografia = Demografias.find(e => e.demografias?.some(a => a.id === quest.demografiaId))?.demografias?.find(e => e.id === quest.demografiaId)
        if (demografia) {
          const demoEscolhida = Respostas.find(e => e.respostaId === demografia.id)
          if (demoEscolhida) {
            naoRespondidas.push(quest)
          }
        }
      } else {
        naoRespondidas.push(quest)
      }
    })
    // if (Questoes.some(e => e.tipo === 1)) {
    //   form.respostasDiscursivas = Questoes.filter(e => e.tipo === 1).map((e) => {
    //     return {
    //       questaoId: e.id,
    //       observacao: e.observacao
    //     } as iRespostaDiscursiva
    //   })
    //   const obrigatorios = form.respostasDiscursivas.filter(e => Obrigatorias.find(r => r === e.questaoId))
    //   if (obrigatorios.length > 0 && !obrigatorios.every(e => e.observacao !== undefined && e.observacao.length >= 3)) {
    //     toast({
    //       title: obterTraduzido('Algumas questões discursivas obrigatórias não foram preenchidas com no mínimo 3 caracteres ',
    //         'Some mandatory discursive questions were not filled in with at least 3 characters',
    //         'Algunas preguntas discursivas obligatorias no se completaron con al menos 3 caracteres'),
    //       status: 'error',
    //       isClosable: false,
    //       position: 'top-right',
    //       duration: 4000
    //     })
    //   }
    // }
    if (naoRespondidas.length > 0) {
      setErrors(naoRespondidas.map(e => e.id))
      toast({
        title: 'Alguns campos não foram preenchidos, revise o formulário e veja se possui campos em vermelho',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      AddErrorStats(naoRespondidas.map((e) => {
        return e.id
      }))
    } else {
      const form: iResposta[] = Respostas

      setIsLoading(true)
      appApi.post(`ResponderPec/${tokenId}/Responder?m=${quiosque ? 'q' : ''}`, form)
        .then((res) => {
          setisRespondido(true)
          if (acessoPec) {
            appApi.post('api/PecAcesso/Resposta', { acessoId: acessoPec.id, pesquisaId: acessoPec.pesquisaId })
              .then(() => {
                if (quiosque) {
                  setTimeout(() => {
                    nav(res.data)
                  }, 4000)
                } else if (LinkRedirecionar) {
                  setTimeout(() => {
                    window.location.href = LinkRedirecionar
                  }, 3000)
                }
              })
              .catch(() => {})
              .finally(() => {
                localStorage.removeItem('acessoPec:id')
                localStorage.removeItem('acessoPec')
              })
          } else {
            if (quiosque) {
              setTimeout(() => {
                nav(res.data)
              }, 4000)
            } else if (LinkRedirecionar) {
              setTimeout(() => {
                window.location.href = LinkRedirecionar
              }, 3000)
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  function ReturnQuestoes(e: iFormQuestao, i: number, isAtrelada?: boolean): any {
    let atrelada: iFormQuestao | undefined = Questoes.find(a => a.perguntaId === e.perguntaAtreladaId)
    const resp = Respostas.find(a => a.questaoId === e.perguntaId)
    if (resp) {
      const peso = EscalaRespostas.find(a => a.id === resp.respostaId)
      if (!peso || (peso.peso > (e.pesoAtrelada ?? 0) || peso.peso === -1)) {
        atrelada = undefined
      }
    } else {
      atrelada = undefined
    }

    if (e.atributoId === 'ab2d00c8-67db-4477-9460-cf440a6964cb' || e.atributoId === '4fd26649-b408-478d-b4a7-c797163f1a7a' || e.atributoId === 'a92f6984-e374-4bb5-a319-69ac12c3804f') return

    return (
    <Flex flexDir={'column'} gap={'1rem'} w={'full'}>
      <Flex flexDir={'column'} key={e.id} tabIndex={0} ref={(el) => (refs.current[i] = el)}>
        <SkillQuestion>
          <div>
            <Flex gap={'.5rem'} alignItems={'center !important'} py={'.25rem'}>
              <Flex gap={'.5rem'} alignItems={'center !important'} justifyContent={'center'}>
                {isAtrelada && <FaShare color='var(--Azul)'/>}
              </Flex>
              <Flex flexDirection={'column'} fontSize={'16px'} w={'100%'}>
                <Flex alignItems={'center'} gap={'6px'}>
                  <Flex gap={'.75rem'}>
                    <Text fontSize={'16px'}>{EmpresaId === 'da14cb39-428b-4cf3-87c4-aa7538fba802' ? e.enunciado.replaceAll('organização', 'Petrocoque').replaceAll('Organização', 'Petrocoque') : e.enunciado}</Text>
                    {AudiosQuestoes?.questoes && AudiosQuestoes?.questoes.length > 0 && EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && AudiosQuestoes && <>
                      <audio ref={(el) => (refsQuestoes.current[i] = el)}>
                        <source src={AudiosQuestoes.questoes.find(q => q.questaoId === e.perguntaId)?.audioUrl} type="audio/mpeg" />
                        Seu navegador não suporta o elemento de áudio.
                      </audio>
                      <ButtonCmp VarColor='Green2' onClick={() => playAudio(i, 3)}><AiFillSound size={20}/></ButtonCmp>
                    </>}
                  </Flex>
                  {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'700'}>* Resposta pendente</Flex>}
                </Flex>
              </Flex>
            </Flex>
          </div>
          {
            EscalaRespostas.map((r: iRespostaEscala, i2) => {
              return (
                <Flex as={'span'} gap={'1rem'} w={'full'} alignItems={'center'}>
                  <SkillAnswer
                    key={i2}
                    type="button"
                    isSelected={isSelect(e.perguntaId ?? '', r.id)}
                    onClick={() => SelResposta(e.perguntaId ?? '', r.id)}
                  >
                    <div>
                      <FaCheckCircle />
                    </div>
                    {EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && <Flex as={'span'} alignItems={'center'} bg={'var(--c1)'} borderRadius={'50%'} justifyContent={'center'} boxSize={'fit-content'} w={'35px'} mx='6px' h={'37px'}>
                      <Img width={'50px'} mt={'3px'} src={r.urlAvatar}/>
                    </Flex>}
                    <span>{r.resposta}</span>
                  </SkillAnswer>
                  {AudiosEscala?.questoes && AudiosEscala?.questoes.length > 0 && EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && AudiosEscala && <>
                    <audio ref={(el) => (refsEscala.current[i2] = el)}>
                      <source src={AudiosEscala.questoes.find(q => q.questaoId === r.id)?.audioUrl} type="audio/mpeg" />
                      Seu navegador não suporta o elemento de áudio.
                    </audio>
                    <ButtonCmp VarColor='Green2' onClick={() => playAudio(i2, 1)}><AiFillSound size={20}/></ButtonCmp>
                  </>}
                </Flex>
              )
            })
          }
          {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex justifyContent={'center'} fontSize={'.875rem'} color={'var(--Red)'} mt={'.5rem'} fontWeight={'700'}>Selecione uma alternativa para essa questão!</Flex>}
        </SkillQuestion>
      </Flex>
      {atrelada && <Flex pl={'2.5rem'} minW={'100%'}>
        {ReturnQuestoes(atrelada, i, true)}
      </Flex>}
    </Flex>)
  }

  function GetQtdItensAntes(index: number): number {
    let qtd = 0
    Demografias.forEach((d, i) => {
      if (i < index) {
        qtd += d.demografias?.length ?? 0
      }
    })

    return qtd
  }

  useEffect(() => {
    getFormulario()
  }, [])

  useEffect(() => {
    if (EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && PesquisaId && PesquisaId !== '' && !IsLoadingForm) {
      getAudios()
    }
  }, [IsLoadingForm])

  return (
    <Body>
      <LoadingContainer linhas={25} loading={IsLoading}>
        <WhiteContainer padding='0'>
          <HeaderContainer>
            <Flex flexDir={'column'}>
              <h1>{NomePesquisa}</h1>
            </Flex>
            <Img alt='Logo da empresa' src={LogoEmpresa ?? 'https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png'} />
          </HeaderContainer>
          <Box bg='var(--DegradeAzul)' className={'gradient-blue'} h={'3px'} w={'full'}></Box>
          {
            (!isRespondido && Questoes.length > 0) && (
              <Container>
                {Demografias.filter(e => {
                  if (!acessoPec) return e

                  if (acessoPec.demografias.some(d => d.demografiaId === e.id)) return null

                  return e
                }).map((e, i) => {
                  return (
                    <Flex flexDir={'column'} key={e.id}>
                        <SkillQuestion>
                          <div>
                            <Flex gap={'.5rem'} alignItems={'center !important'} py={'.25rem'}>
                              <Flex w={'2rem'} h={'2rem'} alignItems={'center'}>
                                <FaChartPie size={'2rem'} color={'var(--Azul)'}/>
                              </Flex>
                              <Flex flexDirection={'column'} w={'100%'} mt={'0 !important'} justifyContent={'center'}>
                                <Text color={'var(--Gray3)'} fontSize={'13px'}>Demografia:</Text>
                                <Flex alignItems={'center'} gap={'6px'}>
                                  <Text fontSize={'16px'}>{e.pergunta}</Text>
                                  {AudiosDemografia?.questoes && AudiosDemografia?.questoes.length > 0 && EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && AudiosDemografia && <>
                                    <audio ref={(el) => (refsDemografia.current[i] = el)}>
                                      <source src={AudiosDemografia.questoes.find(q => q.questaoId === e.id)?.audioUrl} type="audio/mpeg" />
                                      Seu navegador não suporta o elemento de áudio.
                                    </audio>
                                    <ButtonCmp VarColor='Green2' onClick={() => playAudio(i, 0)}><AiFillSound size={20}/></ButtonCmp>
                                  </>}
                                  {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.id) && <Flex fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'700'}>* Resposta pendente</Flex>}
                                </Flex>
                              </Flex>
                            </Flex>
                          </div>
                          {
                            e.demografias?.map((r, i2) => {
                              return (
                                <Flex as={'span'} gap={'1rem'} w={'full'} alignItems={'center'}>
                                  <SkillAnswer
                                    key={i2}
                                    type="button"
                                    isSelected={isSelect(e.id, r.id)}
                                    onClick={() => SelResposta(e.id, r.id)}
                                  >
                                    <div>
                                      <FaCheckCircle />
                                    </div>
                                    <span>{r.nome}</span>
                                  </SkillAnswer>
                                  {EmpresaId === 'd36e2a35-becf-49f2-9314-b0d843e337d5' && AudiosItemDemografia && AudiosItemDemografia.questoes.length > 0 && <>
                                    <audio ref={(el) => (refsItensDemografia.current[i2 + GetQtdItensAntes(i)] = el)}>
                                      <source src={AudiosItemDemografia.questoes.find(q => q.questaoId === r.id)?.audioUrl} type="audio/mpeg" />
                                      Seu navegador não suporta o elemento de áudio.
                                    </audio>
                                    <ButtonCmp VarColor='Green2' onClick={() => playAudio(i2 + GetQtdItensAntes(i), 2)}><AiFillSound size={20}/></ButtonCmp>
                                  </>}
                                </Flex>
                              )
                            })
                          }
                        <Flex justifyContent={'end'} alignItems={'center'} pt={'1rem'}>
                          <ButtonCmp small onClick={() => setRespostas(Respostas.filter(rp => rp.questaoId !== e.id))} VarColor={'c6'}>Limpar resposta</ButtonCmp>
                        </Flex>
                        {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.id) && <Flex justifyContent={'center'} fontSize={'.875rem'} color={'var(--Red)'} mt={'.5rem'} fontWeight={'700'}>Selecione uma alternativa para essa questão!</Flex>}
                        </SkillQuestion>
                      </Flex>
                  )
                })}
                {
                  Questoes.filter(e => {
                    if (Questoes.some(a => a.perguntaAtreladaId === e.perguntaId)) {
                      return null
                    } else if (e.demografiaId === null) {
                      return e
                    } else if (Respostas.some(a => a.respostaId === e.demografiaId)) {
                      return e
                    } else {
                      return null
                    }
                  }).map((e, i) => {
                    return (
                      ReturnQuestoes(e, i)
                    )
                  })
                }

                {
                  Questoes.filter(e => {
                    if (Questoes.some(a => a.perguntaAtreladaId === e.id)) {
                      return null
                    } else if (e.demografiaId === null) {
                      return e
                    } else if (Respostas.some(a => a.respostaId === e.demografiaId)) {
                      return e
                    } else {
                      return null
                    }
                  })?.filter(e => e.atributoId === '4fd26649-b408-478d-b4a7-c797163f1a7a' || e.atributoId === 'a92f6984-e374-4bb5-a319-69ac12c3804f').map((e, i) => {
                    return (
                      <Flex flexDir={'column'} key={e.id}>
                        <SkillQuestion>
                          <div>
                            <Flex gap={'.5rem'} alignItems={'center !important'} py={'.25rem'}>
                              <Flex flexDirection={'column'} fontSize={'16px'} w={'100%'}>
                                <Flex alignItems={'center'} gap={'6px'}>
                                  <Text fontSize={'16px'}>{e.enunciado}</Text>
                                  {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'700'}>* Resposta pendente</Flex>}
                                </Flex>
                              </Flex>
                            </Flex>
                          </div>
                          <RadioGroup size={'md'} value={Respostas.find(a => a.questaoId === e.perguntaId)?.nota}>
                            <Stack direction={'row'} gap={'1rem'} px={'1.5rem'}>
                              {
                                Notas.map((r, i2) => {
                                  return (
                                    <Flex
                                      flexDir={'column'}
                                      key={i2}
                                      cursor={'pointer'}
                                      alignItems={'center !important'}
                                      justifyContent='center'
                                      onClick={() => SelResposta(e.perguntaId ?? '', undefined, r)}
                                    >
                                      <Radio style={{ cursor: 'pointer' }} value={r}/>
                                      <Text color={'black'} fontWeight={700} fontSize={'18px'}>{r}</Text>
                                    </Flex>
                                  )
                                })
                              }
                            </Stack>
                          </RadioGroup>
                          {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex justifyContent={'center'} fontSize={'.875rem'} color={'var(--Red)'} mt={'.5rem'} fontWeight={'700'}>Selecione uma alternativa para essa questão!</Flex>}
                        </SkillQuestion>
                      </Flex>
                    )
                  })
                }

                {Questoes.filter(e => e.atributoId === 'ab2d00c8-67db-4477-9460-cf440a6964cb').some(e => !e.ordem)
                  ? Questoes.filter(e => e.atributoId === 'ab2d00c8-67db-4477-9460-cf440a6964cb').map((e, i) => {
                    return (
                      <Flex flexDir={'column'} key={e.id}>
                        <SkillQuestion>
                          <div>
                            <Flex gap={'.5rem'} alignItems={'center !important'} py={'.25rem'}>
                              <Flex flexDirection={'column'} fontSize={'16px'} w={'100%'}>
                                <Flex alignItems={'center'} gap={'6px'}>
                                  <Text fontSize={'16px'}>{e.enunciado}</Text>
                                  {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'700'}>* Resposta pendente</Flex>}
                                </Flex>
                              </Flex>
                            </Flex>
                          </div>
                          <ComentarioContainer key={e.id}>
                            <textarea
                              placeholder={'Digite um comentário sobre o avaliado'}
                              onChange={(r) => UpdateRespostaDiscursiva(e.perguntaId ?? '', r.target.value)}
                              minLength={3}
                              value={Respostas.find(a => a.questaoId === e.perguntaId)?.resposta}
                            />
                          </ComentarioContainer>
                          {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex justifyContent={'center'} fontSize={'.875rem'} color={'var(--Red)'} mt={'.5rem'} fontWeight={'700'}>O comentário deve ter no mínimo 5 caracteres!</Flex>}
                        </SkillQuestion>
                      </Flex>
                    )
                  })
                  : Questoes.filter(e => e.atributoId === 'ab2d00c8-67db-4477-9460-cf440a6964cb').sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return -1 } }).map((e, i) => {
                    return (
                      <Flex flexDir={'column'} key={e.id}>
                        <SkillQuestion>
                          <div>
                            <Flex gap={'.5rem'} alignItems={'center !important'} py={'.25rem'}>
                              <Flex flexDirection={'column'} fontSize={'16px'} w={'100%'}>
                                <Flex alignItems={'center'} gap={'6px'}>
                                  <Text fontSize={'16px'}>{e.enunciado}</Text>
                                  {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex fontSize={'.813rem'} color={'var(--Red)'} fontWeight={'700'}>* Resposta pendente</Flex>}
                                </Flex>
                              </Flex>
                            </Flex>
                          </div>
                          <ComentarioContainer key={e.id}>
                            <textarea
                              placeholder={'Digite um comentário sobre o avaliado'}
                              onChange={(r) => UpdateRespostaDiscursiva(e.perguntaId ?? '', r.target.value)}
                              minLength={3}
                              value={Respostas.find(a => a.questaoId === e.perguntaId)?.resposta}
                            />
                          </ComentarioContainer>
                          {Errors.some(a => a === e.id) && !Respostas.some(a => a.questaoId === e.perguntaId) && <Flex justifyContent={'center'} fontSize={'.875rem'} color={'var(--Red)'} mt={'.5rem'} fontWeight={'700'}>O comentário deve ter no mínimo 5 caracteres!</Flex>}
                        </SkillQuestion>
                      </Flex>
                    )
                  })
                }
                {!pathname.includes('Previsualizar') &&
                  <Flex justifyContent={'center'} margin={'1rem 0rem'}>
                    <ButtonCmp onClick={postForm} h={'2.125rem'} fontSize={'1rem'} VarColor='Green2'>Enviar resposta</ButtonCmp>
                  </Flex>}
                {pathname.includes('Previsualizar') &&
                  <Flex marginTop={'1rem'} justifyContent={'flex-end'}>
                    <ButtonCmp
                      h={'2.125rem'}
                      fontSize={'1rem'}
                      VarColor='Rosa'
                      onClick={() => nav(-1)}
                    >Finalizar pré-visualização</ButtonCmp>
                  </Flex>
                }
              </Container>
            )
          }

          {
            (isRespondido) && (
              <Flex background={'white'} height={'100%'}>
                <Flex padding={'3rem 3rem'} flexDirection={'column'}>
                  <h3 dangerouslySetInnerHTML={{
                    __html: FormatarMensagemEditorDeTexto(TxtEncerramento && TxtEncerramento !== '' ? TxtEncerramento : 'Obrigado pela participação!')
                  }}></h3>
                  <Text
                    fontWeight={'400'}
                    style={{
                      color: 'var(--Gray3)',
                      marginTop: '.25rem'
                    }}>
                    Respostas enviadas com sucesso!</Text>
                  {
                    (localStorage.getItem('token')) && (
                      <Flex marginTop={'.75rem'}>
                        <ButtonCmp
                          h={'2.125rem'}
                          fontSize={'1rem'}
                          VarColor='Green2'
                          onClick={() => nav('/')}
                        >Voltar</ButtonCmp>
                      </Flex>
                    )
                  }
                </Flex>
              </Flex>
            )
          }
        </WhiteContainer>
      </LoadingContainer>
    </Body>
  )
}
